import { createAsyncThunk } from "@reduxjs/toolkit";
import { DocumentTeamMemberRole } from "../../../documents/components/teamMemberApi";
import { getWithAuth, postWithAuth } from "../../../../http";
import { AppThunkAPIType } from "../../../../app/appTypes";


export interface CompanyRoleResponsibility {
    roleCode: DocumentTeamMemberRole;
    responsibilityPl: string;
    responsibilityEn: string;
    isSystem: boolean;
}


export const loadCompanyRoleResponsibilities = createAsyncThunk<CompanyRoleResponsibility[], void, AppThunkAPIType>("company-role-responsibilities/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/company-role-responsibilities` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as CompanyRoleResponsibility[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const overrideCompanyRoleResponsibility = createAsyncThunk<CompanyRoleResponsibility, { roleResponsibility: CompanyRoleResponsibility }, AppThunkAPIType>(
    "company-role-responsibilities/override",
    async ({ roleResponsibility }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            postWithAuth({
                url: `api/company-role-responsibilities/override`,
                payload: roleResponsibility,
            })
        )
        const { payload } = result
        if (postWithAuth.fulfilled.match(result)) {
            return payload as CompanyRoleResponsibility
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" })
        }
    }
)

export const restoreCompanyRoleResponsibility = createAsyncThunk<CompanyRoleResponsibility, { roleCode: string }, AppThunkAPIType>(
    "company-role-responsibilities/restore",
    async ({ roleCode }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            postWithAuth({
                url: `api/company-role-responsibilities/restore/${roleCode}`,
                payload: {  }
            })
        )
        const { payload } = result
        if (postWithAuth.fulfilled.match(result)) {
            return payload as CompanyRoleResponsibility
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" })
        }
    }
)
